export const environment = {
  production: true,
  apiPath: 'https://rm5api-development.azurewebsites.net/'
};
